import { useRoutes } from "react-router-dom";
import {
  Dashboard,
  DashboardLayout,
  Dispute,
  Mamapurse,
  Notifications,
  Orders,
  Products,
  Services,
  Team,
  Users,
  Banner,
  Categories,
  Delivery,
  ZipTracker,
  InvestorInquiries,
} from "../Pages/Dashboard";
import { Login } from "../Pages/Auth";
import UserDetails from "../Components/Users/UserDetails";
import OrderDetails from "../Components/Orders/OrderDetails";
import DeliveryDetails from "../Components/Delivery/DeliveryDetails";
import { Overview } from "../Components/Products.js";
import ServiceOverview from "../Components/Services/ServiceOverview.js";
import ProtectedRoutes from "../Utils/ProtectedRoutes.js";
import Settings from "../Pages/Dashboard/Settings.js";
import ServiceDetails from "../Components/Orders/ServiceDetails.jsx";
import PaymentRequest from "../Components/Mamapurse/PaymentRequest.jsx";
import Referrals from "../Pages/Dashboard/Referrals.jsx";
import EditProduct from "../Components/Products.js/edit-product.jsx";
import Blogs from "../Pages/Dashboard/Blogs.jsx";
import CreateBlog from "../Components/Blog/create-blog.jsx";

export function Routes() {
  let element = useRoutes([
    {
      path: "/login",
      element: <Login />,
    },
    {
      element: (
        <ProtectedRoutes>
          {" "}
          <DashboardLayout />{" "}
        </ProtectedRoutes>
      ),
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },
        {
          path: "/dashboard/users",
          element: <Users />,
        },
        {
          path: "/dashboard/payment-request",
          element: <PaymentRequest />,
        },
        {
          path: "/dashboard/orders",
          element: <Orders />,
        },
        {
          path: "/dashboard/products",
          element: <Products />,
        },
        {
          path: "/dashboard/services",
          element: <Services />,
        },
        {
          path: "/dashboard/mamapurse",
          element: <Mamapurse />,
        },
        {
          path: "/dashboard/delivery",
          element: <Delivery />,
        },
        {
          path: "/dashboard/categories",
          element: <Categories />,
        },
        {
          path: "/dashboard/banner",
          element: <Banner />,
        },
        {
          path: "/dashboard/ziptracker",
          element: <ZipTracker />,
        },
        {
          path: "/dashboard/investor-inquiries",
          element: <InvestorInquiries />,
        },
        {
          path: "/dashboard/notifications",
          element: <Notifications />,
        },
        {
          path: "/dashboard/team",
          element: <Team />,
        },
        {
          path: "/dashboard/dispute",
          element: <Dispute />,
        },
        {
          path: "/dashboard/user-details/:id",
          element: <UserDetails />,
        },
        {
          path: "/dashboard/order-details/:id",
          element: <OrderDetails />,
        },
        {
          path: "/dashboard/delivery-details/:id",
          element: <DeliveryDetails />,
        },
        {
          path: "/dashboard/order-service-details/:id",
          element: <ServiceDetails />,
        },
        {
          path: "/dashboard/product-details/:id",
          element: <Overview />,
        },
        {
          path: "/dashboard/blog-management",
          element: <Blogs />,
        },
        {
          path: "/dashboard/blog-management/create",
          element: <CreateBlog />,
        },
        {
          path: "/dashboard/blog-management/edit/:id",
          element: <CreateBlog />,
        },
        {
          path: "/dashboard/product/edit/:id",
          element: <EditProduct />,
        },
        {
          path: "/dashboard/service-details/:id",
          element: <ServiceOverview />,
        },
        {
          path: "/dashboard/settings",
          element: <Settings />,
        },
        {
          path: "/dashboard/referrals",
          element: <Referrals />,
        },
      ],
    },
  ]);
  return element;
}
